module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-list",
    class: [_vm.bemFacet]
  }, [_c('ul', {
    staticClass: "u-reset link-list--list"
  }, _vm._l((_vm.entries), function(entry, entryIdx) {
    return _c('li', {
      staticClass: "link-list--item"
    }, [_c('span', {
      staticClass: "u-reset link-list--link",
      class: [entry.multi_line ? ' link-list--link__top-align' : ''],
      attrs: {
        "title": entry.title || entry.label
      }
    }, [_c('a', {
      staticClass: "link-list--icon",
      attrs: {
        "href": entry.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('cmp-icon', {
      staticClass: "link-list--icon-inner",
      attrs: {
        "symbol": entry.icon,
        "size": "small"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "link-list--text"
    }, [_c('a', {
      staticClass: "u-reset link-list--text-inner",
      attrs: {
        "href": entry.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      domProps: {
        "innerHTML": _vm._s(entry.label)
      }
    }), _vm._v(" "), (entry.additional_content) ? _c('span', {
      staticClass: "link-list--additional-content",
      domProps: {
        "innerHTML": _vm._s(entry.additional_content)
      }
    }) : _vm._e()])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50edcbb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50edcbb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/contact-link-list/index.vue
// module id = 545
// module chunks = 7